import { Types } from './types'

const initialState = {
    dataCategory: [],
    dataBlog: {
        rows: [],
        paging: {}
    },
    dataBlogCategory: {
        rows: [],
        paging: {}
    },
    dataTag: [],
    dataAllTag: []
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_CATEGORY:
            return {
                ...newState,
                dataCategory: action.payload
            }
        case Types.SAVE_LIST_BLOG:
            return {
                ...newState,
                dataBlog: action.payload
            }
        case Types.SAVE_LIST_BLOG_CATEGORY:
            return {
                ...newState,
                dataBlogCategory: action.payload
            }
        case Types.SAVE_LIST_TAG:
            return {
                ...newState,
                dataTag: action.payload
            }
        case Types.SAVE_ALL_TAG:
            return {
                ...newState,
                dataAllTag: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer